module.exports = __webpack_public_path__ + "static/media/machine_learning.9cf64983.mp4";